import { cognitoFields, createDeploymentConfig, type RuntimeConfig } from "@jkast90/kast-common/config";

declare global {
  interface Window {
    RUNTIME_CONFIG?: RuntimeConfig;
  }
}

const { cognitoDomain, clientId } = cognitoFields();

/** Each field from window.RUNTIME_CONFIG (/config.js), then the build's env, else "". */
export const cognitoConfig = createDeploymentConfig({
  env: import.meta.env,
  storage: null,
  fields: {
    userPoolId: "VITE_COGNITO_USER_POOL_ID",
    // The domain and client ID are the fields every app repeats; the sign-in site is its own login URL.
    cognitoDomain,
    clientId,
  },
});

export const getCognitoConfig = cognitoConfig.get;
